import * as Mui from '@mui/material';
const { OutlinedInput } = Mui;
export default OutlinedInput;
//# sourceMappingURL=index.js.map